import { Form, Select, Tag } from "antd";
import { tagsSelector } from "appredux/selectors";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";

const TagSelector = (props) => {
  const { t } = useTranslation();
  const tags = useSelector(tagsSelector);
  const tagRender = useCallback(
    (innerProps) => {
      const { label, value, closable, onClose } = innerProps;
      const findTag = tags.find((tag) => tag.id === value);

      const onPreventMouseDown = (event) => {
        event.preventDefault();
        event.stopPropagation();
      };

      // const closeHanlder = () => {
      //   onClose();
      //   if (typeof onAfterDelete === "function") {
      //     onAfterDelete(value);
      //   }
      // };

      return (
        <Tag
          color={findTag?.color}
          onMouseDown={onPreventMouseDown}
          closable={closable}
          onClose={onClose}
          className="m-1"
        >
          {label}
        </Tag>
      );
    },
    [tags]
  );
  return (
    <Form.Item label={t("tag")} name="tag_ids" {...props}>
      <Select
        placeholder={t("select_tag")}
        options={tags}
        allowClear
        fieldNames={{ label: "name", value: "id" }}
        showSearch
        filterOption
        tagRender={tagRender}
        optionFilterProp="name"
        mode="multiple"
      />
    </Form.Item>
  );
};

export default TagSelector;
